import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "title" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "使用條款", -1)
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_ScrollWrap = _resolveComponent("ScrollWrap")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal",
    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.$style.basic, 'card'])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_Button, {
          btnName: "Close",
          btyType: "close",
          title: "關閉",
          class: "close",
          onClick: _cache[0] || (_cache[0] = () => _ctx.setModal(_ctx.ModalType.None))
        })
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.content)
      }, [
        _createVNode(_component_ScrollWrap, {
          class: _normalizeClass(_ctx.$style.terms)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", { innerHTML: _ctx.markdownHtml }, null, 8, _hoisted_3)
          ]),
          _: 1
        }, 8, ["class"])
      ], 2)
    ], 2)
  ]))
}